import {
  FormButtonBelowContent,
  FormContent,
  FormContentBody,
  FormContentHeadings,
  InputBox,
  InputBoxContainer,
  InputBoxInsideContainer,
  QuestionSubtext,
} from 'src/consumer/components/Form/FormStyles'
import { CustomHTMLSelect } from 'src/consumer/components/helperComponents'
import { FREQUENCY_RATE_OPTIONS } from '../../utils'
import { FrequencySelectionHeading } from './styledComponents'

export default function FrequencySelection({ formData, setFormData, goToNextPage }) {
  function setAddictionFrequency(value) {
    setFormData((prev) => {
      return {
        ...prev,
        frequency: value,
      }
    })
  }

  function setAddictionFrequencyRate(value) {
    setFormData((prev) => {
      return {
        ...prev,
        frequencyRate: value,
      }
    })
  }
  function nextPage() {
    goToNextPage()
  }

  function checkDisabled() {
    if (formData?.frequency && formData?.frequencyRate) {
      return false
    }
    return true
  }

  return (
    <>
      <FormContent>
        <FormContentHeadings>
          <FrequencySelectionHeading>
            How frequently do you engage in this addiction?
          </FrequencySelectionHeading>
          <QuestionSubtext>
            We respect your privacy, we just need some info to create the right plan for you.
          </QuestionSubtext>
        </FormContentHeadings>
        <FormContentBody>
          <InputBoxContainer style={{ margin: '5px 0' }}>
            <InputBoxInsideContainer>
              <InputBox
                type="number"
                value={formData?.frequency}
                placeholder="Frequency"
                onChange={(e) => setAddictionFrequency(e.target.value)}
              />
              <div
                className="d-flex align-items-center justify-content-end h-100 flex-shrink-0"
                style={{ fontSize: '20px' }}
              >
                <span>times per</span>
                <CustomHTMLSelect
                  value={formData?.frequencyRate}
                  onChange={(e) => setAddictionFrequencyRate(e.target.value)}
                  getOptionLabel={(opt) => opt?.value}
                  getOptionValue={(opt) => opt?.id}
                  options={FREQUENCY_RATE_OPTIONS}
                  style={{
                    background: 'transparent',
                    padding: '5px 16px 5px 2px',
                  }}
                />
              </div>
            </InputBoxInsideContainer>
          </InputBoxContainer>
          <span style={{ color: 'transparent', fontWeight: '600' }}>placeholder</span>
        </FormContentBody>
      </FormContent>
      <FormButtonBelowContent onClick={nextPage} disabled={checkDisabled()}>
        Continue
      </FormButtonBelowContent>
    </>
  )
}

/* <MultiSelectComponentITS
            data={formData?.addictionTypes}
            setDataFunction={setAddictionType}
            options={addictionOptions}
          /> */
